import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appDate',
  standalone: true
})
export class AppDatePipe implements PipeTransform {
  private readonly datePipe = new DatePipe('en-US');

  transform(
    value: Date | string | number | null | undefined,
    format: string = 'mediumDate',
    timezone?: string,
    locale?: string
  ): string | null {
    const normalizedValue = this.normalizeDateValue(value);
    if (normalizedValue === null) {
      return null;
    }

    return this.datePipe.transform(normalizedValue, format, timezone, locale);
  }

  private normalizeDateValue(value: Date | string | number | null | undefined): Date | string | number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (value instanceof Date) {
      return value;
    }

    if (typeof value === 'number') {
      return this.normalizeEpoch(value);
    }

    const trimmedValue = value.trim();
    if (!trimmedValue) {
      return null;
    }

    const numericValue = Number(trimmedValue);
    if (!Number.isNaN(numericValue) && Number.isFinite(numericValue)) {
      return this.normalizeEpoch(numericValue);
    }

    return trimmedValue;
  }

  private normalizeEpoch(value: number): number {
    return Math.abs(value) < 1_000_000_000_000 ? value * 1000 : value;
  }
}
